export const courses = {
  live: [
    {
      id: 1,
      title: "Ethical Hacking Course — Effectively with AI",
      category: "Ethical Hacking",
      duration: "48 Hrs",
      trainingType: "LIVE Instructor-led Training",
      image: "https://images.unsplash.com/photo-1563206767-5b18f218e8de?w=800",
      exlyLink: "https://exly.live/placeholder-ethical-hacking",
      features: ["Hands-on Labs", "Real-world Projects", "Certification"]
    },
    {
      id: 2,
      title: "SOC Analyst - Security Operations Center Training",
      category: "SOC Analyst",
      duration: "60 Hrs",
      trainingType: "LIVE Instructor-led Training",
      image: "https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?w=800",
      exlyLink: "https://indiancyberclub.in/checkout/1ba1f51f-ea6d-46a1-988e-83362924dcb4",
      features: ["SIEM Tools", "Threat Detection", "Incident Response"]
    },
    {
      id: 3,
      title: "Bug Bounty Hunter - Web Application Security",
      category: "Bug Bounty",
      duration: "50 Hrs",
      trainingType: "LIVE Instructor-led Training",
      image: "https://images.pexels.com/photos/5380664/pexels-photo-5380664.jpeg?w=800",
      exlyLink: "https://exly.live/xJBMRo",
      features: ["OWASP Top 10", "Practical Hunting", "Report Writing"]
    },
    {
      id: 4,
      title: "Master VAPT (Vulnerability Assessment & Penetration Testing)",
      category: "VAPT",
      duration: "40 Hrs",
      trainingType: "LIVE Instructor-led Training",
      image: "https://images.pexels.com/photos/5380664/pexels-photo-5380664.jpeg?w=800",
      exlyLink: "https://exly.live/placeholder-vapt",
      features: ["Network Security", "Web App Testing", "Mobile App Security"]
    },
    {
      id: 5,
      title: "Digital Forensics Investigation",
      category: "Forensics",
      duration: "36 Hrs",
      trainingType: "LIVE Instructor-led Training",
      image: "https://images.unsplash.com/photo-1516382799247-87df95d790b7?w=800",
      exlyLink: "https://exly.live/placeholder-forensics",
      features: ["Evidence Collection", "Data Recovery", "Legal Procedures"]
    },
    {
      id: 6,
      title: "Linux for Cybersecurity Professionals",
      category: "Linux",
      duration: "30 Hrs",
      trainingType: "LIVE Instructor-led Training",
      image: "https://images.unsplash.com/photo-1629654297299-c8506221ca97?w=800",
      exlyLink: "https://exly.live/placeholder-linux",
      features: ["Command Line Mastery", "Shell Scripting", "System Security"]
    }
  ],
  selfPaced: [
    {
      id: 7,
      title: "Python For Ethical Hackers",
      category: "Self-Paced",
      lectures: "30 Lectures",
      description: "Master Python programming for cybersecurity applications",
      image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800",
      exlyLink: "https://exly.live/placeholder-python"
    },
    {
      id: 8,
      title: "Advanced WiFi Hacking",
      category: "Self-Paced",
      lectures: "18 Lectures",
      description: "Hands-on WiFi security testing techniques",
      image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800",
      exlyLink: "https://exly.live/placeholder-wifi"
    },
    {
      id: 9,
      title: "Web Application Penetration Testing",
      category: "Self-Paced",
      lectures: "35 Lectures",
      description: "Comprehensive web security testing methodology",
      image: "https://images.pexels.com/photos/6963932/pexels-photo-6963932.jpeg?w=800",
      exlyLink: "https://exly.live/placeholder-webapp"
    },
    {
      id: 10,
      title: "Android Security & Hacking",
      category: "Self-Paced",
      lectures: "18 Lectures",
      description: "Mobile app security and penetration testing",
      image: "https://images.unsplash.com/photo-1624969862644-791f36dc91a7?w=800",
      exlyLink: "https://exly.live/placeholder-android"
    },
    {
      id: 11,
      title: "Network Security Fundamentals",
      category: "Self-Paced",
      lectures: "28 Lectures",
      description: "Complete network security and defense strategies",
      image: "https://images.pexels.com/photos/6964137/pexels-photo-6964137.jpeg?w=800",
      exlyLink: "https://exly.live/placeholder-network"
    },
    {
      id: 12,
      title: "Bash Scripting for Hackers",
      category: "Self-Paced",
      lectures: "25 Lectures",
      description: "Automation and scripting for security professionals",
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800",
      exlyLink: "https://exly.live/placeholder-bash"
    }
  ],
  Advance Training: [
    {
      id: 13,
      title: "One Year Advance Training Program in Cybersecurity",
      category: "Cybersecurity Advance Training",
      duration: "12 Months",
      trainingType: "Offline/Online Training",
      image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800",
      exlyLink: "https://exly.live/placeholder-1year",
      features: ["Complete Cybersecurity Stack", "Industry Projects", "Placement Support"]
    },
    {
      id: 14,
      title: "6 Months Advance Training in Digital Forensics",
      category: "Forensics Advance Training",
      duration: "6 Months",
      trainingType: "Offline/Online Training",
      image: "https://images.unsplash.com/photo-1516382799247-87df95d790b7?w=800",
      exlyLink: "https://exly.live/placeholder-forensics-diploma",
      features: ["Investigation Techniques", "Legal Knowledge", "Real Cases"]
    },
    {
      id: 15,
      title: "6 Months Advance Training in Cybersecurity",
      category: "Cybersecurity Advance Training",
      duration: "6 Months",
      trainingType: "Offline/Online Training",
      image: "https://images.pexels.com/photos/6964137/pexels-photo-6964137.jpeg?w=800",
      exlyLink: "https://exly.live/placeholder-6months",
      features: ["Core Security Skills", "Practical Labs", "Job-Ready Training"]
    }
  ]
};
